module.exports = __webpack_public_path__ + "static/media/smoothing.2b3e9568.svg";